import { object, string } from 'yup';

import { getQuillPlainText } from '../../../../../components/baseV2';
import {
  DISCHARGE_OTHER_EXPLANATION_MIN_LENGTH,
  DISCHARGE_REASON_OTHER,
  DISCHARGE_RICH_TEXT_MAX_LENGTH,
  DISCHARGE_RICH_TEXT_MIN_VISIBLE_CHARACTERS,
} from './constants';

function buildDischargeCriteriaFieldSchema() {
  return string()
    .max(
      DISCHARGE_RICH_TEXT_MAX_LENGTH,
      `Value must be at most ${DISCHARGE_RICH_TEXT_MAX_LENGTH} characters`,
    )
    .test(
      'min-visible-characters',
      `Enter at least ${DISCHARGE_RICH_TEXT_MIN_VISIBLE_CHARACTERS} visible characters`,
      (value) =>
        getQuillPlainText(value ?? '').replace(/\s/g, '').length >=
        DISCHARGE_RICH_TEXT_MIN_VISIBLE_CHARACTERS,
    )
    .required();
}

export const DISCHARGE_CRITERIA_SCHEMA = object({
  mastery_of_program_goals: buildDischargeCriteriaFieldSchema(),
  titration_plan: buildDischargeCriteriaFieldSchema(),
  readiness_to_step_down: buildDischargeCriteriaFieldSchema(),
  care_coordination: buildDischargeCriteriaFieldSchema(),
});

export const DISCHARGE_REASON_DRAFT_SCHEMA = object({
  reason: string().required(),
  explanation: string()
    .trim()
    .when('reason', {
      is: DISCHARGE_REASON_OTHER,
      then: (schema) =>
        schema
          .min(
            DISCHARGE_OTHER_EXPLANATION_MIN_LENGTH,
            `Enter at least ${DISCHARGE_OTHER_EXPLANATION_MIN_LENGTH} characters`,
          )
          .required(`Enter at least ${DISCHARGE_OTHER_EXPLANATION_MIN_LENGTH} characters`),
    }),
});
